﻿import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { resourceServerUrl } from '../../constants/auth-keys';

@Injectable()
export class HeaderService {
    private getNotificationUri: string = `${resourceServerUrl}/api/Notification/GetNotification`;
    constructor(private http: HttpClient) {
    }
    getNotification(): Observable<HttpResponse<any>> {
        return this.http.get(this.getNotificationUri, { observe: 'response' });
    }
}